import { TipoMetrica, TipoMetricaForm } from "../../types";
import { useForm } from "react-hook-form";
import { ROUTER_PATHS } from "@/shared";
import { useNavigate } from "react-router-dom";
import { CustomTextField, SingleFormBoxScene } from "@/shared/components/ui";
import { useEffect, useState } from "react";
import { useFetchPostTipoMetrica, useFetchPutTipoMetrica } from "@/shared/actions";
import { tipoMetricaSchema } from "../../utils";
import { yupResolver } from "@hookform/resolvers/yup";

type SaveTipoMetricaProps = {
  titulo: string;
  data?: TipoMetrica | null;
};

export default function SaveTipoMetrica({ titulo, data }: SaveTipoMetricaProps) {
  const returnUrl = ROUTER_PATHS.control_cambios.tipoMetricaNav;
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  const createTipoMetrica = useFetchPostTipoMetrica({ navigate, returnUrl });
  const updateTipoMetrica = useFetchPutTipoMetrica(navigate, returnUrl);

  const form = useForm<TipoMetricaForm>({
    resolver: yupResolver(tipoMetricaSchema) as any,
    mode: "onChange",
    defaultValues: {
      nombre: "",
      estado: true,
    },
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  const onSave = () => {
    if (!isValid) return;
    const values = { ...form.getValues() };
    if (data?.tipoMetricaId) {
      return updateTipoMetrica.mutate({
        id: data.tipoMetricaId,
        data: values as any,
      });
    }
    return createTipoMetrica.mutate(values);
  };

  useEffect(() => {
    if (data) {
      setShrink(true);
      reset({
        nombre: data.nombre ?? "",
        estado: data.estado ?? true,
      });
    }
  }, [data]);

  return (
    <SingleFormBoxScene
      titlePage={titulo}
      onCancel={() => navigate(returnUrl)}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Nombre del tipo de métrica"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ""}
        error={errors.nombre}
        helperText={errors.nombre?.message ?? ""}
        shrink={shrink}
      />
    </SingleFormBoxScene>
  );
}
